import { render, staticRenderFns } from "./QuotesPageList.vue?vue&type=template&id=7c87ac5a&scoped=true&"
import script from "./QuotesPageList.vue?vue&type=script&lang=js&"
export * from "./QuotesPageList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesPageList.vue?vue&type=style&index=0&id=7c87ac5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87ac5a",
  null
  
)

export default component.exports